import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    thememobile: {
      type: Object,
      default: function _default() {
        backgroundColor: '';
      }
    },
    bgValue: {
      type: String
    }
  },
  watch: {
    background: function background(val, oldVal) {
      if (val != oldVal) {
        this.$emit('onChange', val);
      }
    },
    bgValue: function bgValue(val, oldVal) {
      if (this.bgValue) {
        this.background = this.bgValue;
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    onThemeBg: function onThemeBg(item) {
      this.background = 'bg-' + this.thememobile.backgroundColor;
      this.$emit('onChange', this.background);
    },
    onBgColor: function onBgColor(item) {
      this.background = 'bg-' + item.name;
      this.$emit('onChange', this.background);
      this.showBgDialog = false;
    }
  },
  components: {},
  data: function data() {
    return {
      background: '',
      showBgDialog: false,
      colorList: [{
        title: '默认',
        name: 'gradual-scarlet',
        color: '#ffffff'
      }, {
        title: '嫣红',
        name: 'red',
        color: '#e54d42'
      }, {
        title: '桔橙',
        name: 'orange',
        color: '#f37b1d'
      }, {
        title: '明黄',
        name: 'yellow',
        color: '#fbbd08'
      }, {
        title: '橄榄',
        name: 'olive',
        color: '#8dc63f'
      }, {
        title: '森绿',
        name: 'green',
        color: '#39b54a'
      }, {
        title: '天青',
        name: 'cyan',
        color: '#1cbbb4'
      }, {
        title: '海蓝',
        name: 'blue',
        color: '#0081ff'
      }, {
        title: '深蓝',
        name: 'darkblue',
        color: '#0055ff'
      }, {
        title: '姹紫',
        name: 'purple',
        color: '#6739b6'
      }, {
        title: '木槿',
        name: 'mauve',
        color: '#9c26b0'
      }, {
        title: '桃粉',
        name: 'pink',
        color: '#e03997'
      }, {
        title: '棕褐',
        name: 'brown',
        color: '#a5673f'
      }, {
        title: '玄灰',
        name: 'grey',
        color: '#8799a3'
      }, {
        title: '草灰',
        name: 'gray',
        color: '#aaaaaa'
      }, {
        title: '墨黑',
        name: 'black',
        color: '#333333'
      }, {
        title: '雅白',
        name: 'white',
        color: '#ffffff'
      }, {
        title: '粉红',
        name: 'gradual-red',
        color: '#ffffff'
      }, {
        title: '橙红',
        name: 'gradual-orange',
        color: '#ffffff'
      }, {
        title: '绿青',
        name: 'gradual-green',
        color: '#ffffff'
      }, {
        title: '紫红',
        name: 'gradual-purple',
        color: '#ffffff'
      }, {
        title: '粉紫',
        name: 'gradual-pink',
        color: '#ffffff'
      }, {
        title: '蓝绿',
        name: 'gradual-blue',
        color: '#ffffff'
      }, {
        title: '黑灰',
        name: 'gradual-gray',
        color: '#ffffff'
      }, {
        title: '淡蓝',
        name: 'gradual-darkblue',
        color: '#ffffff'
      }, {
        title: '默认',
        name: 'scarlet',
        color: '#ffffff'
      }]
    };
  },
  computed: {},
  created: function created() {},
  updated: function updated() {},
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated: function activated() {}
};